
import { useFormik } from 'formik';
import * as Yup from "yup";

import React, { useEffect } from 'react';

const BfFormstep21 = ({lang, setLang, nextStep, backStep, nextStepby2, backStepby2, formData}) => {

    // useEffect to check formData.step22 and call nextStepby2 on component load
    useEffect(() => {
        if (Object.keys(formData.step22).length > 0) {
            nextStepby2();
        }
    }, []); // Empty dependency array to ensure this runs only once on component load

    return (
        // Your component rendering logic here
  


    






<>
  <header className="c-site-header">
    <a className="c-site-header__skip js-site-header-skip" href="#main">
      Skip to main contenti 
    </a>
    <div className="o-wrapper">
      <a
        className="c-site-header__logo-link"
        href="./"
        aria-label="Go to home page"
      >
        <img
          className="c-site-header__logo"
          src="images/components/site-header/logo-blf-specialty.svg"
          alt="Bluefire Specialty Logo"
          width={100}
          height={34}
        />
      </a>
      <h1 className="c-site-header__title">
          <span className="o-icon">
            <svg aria-hidden="true" focusable="false" role="img">
              <use href="images/icons/icons.svg#icon-drivers" />
            </svg>
          </span>
          {lang === 'eng' ? 'Drivers Information' : 'Información de conductores'}
        </h1>
      <div className="c-site-header__controls c-header-controls">
      <button 
    className="c-header-controls__language" 
    onClick={() => setLang(lang === 'eng' ? 'spa' : 'eng')}  // Toggle the language
  >
    <span className="o-icon c-header-controls__icon">
      <svg aria-hidden="true" focusable="false" role="img">
        <use href="images/icons/icons.svg#icon-language" />
      </svg>
    </span>
    <span className="u-hidden-visually">
      {lang === 'eng' ? 'Switch to Spanish' : 'Switch to English'}
    </span>
    <span className="c-header-controls__text">
      {lang === 'eng' ? 'Español' : 'English'}
    </span>
  </button>
      </div>
    </div>
  </header>
  <main className="c-main-content">
    <div className="c-section">
      <div className="o-wrapper o-wrapper--small">
        <h1 className="c-section__title">
          <span className="o-icon">
            <svg aria-hidden="true" focusable="false" role="img">
              <use href="images/icons/icons.svg#icon-drivers" />
            </svg>
          </span>
          {lang === 'eng' ? 'Drivers Information' : 'Información de conductores'}
        </h1>
        <div className="c-section__content">
          <div className="c-steps">
            <ul className="o-list-bare c-steps__list">
              <li className="o-list-bare__item c-steps__item c-steps__item--100 c-steps__step--completed">
                <div className="c-steps__step">
                <div className="c-steps__text">{lang === 'eng' ? 'Applicant' : 'Solicitante'}</div>
                  <div className="c-steps__circle" />
                </div>
              </li>
              <li className="o-list-bare__item c-steps__item c-steps__item--20 c-steps__step--active">
                <div className="c-steps__step c-steps__step">
                <div className="c-steps__text">{lang === 'eng' ? 'Drivers' : 'Conductores'} </div>
                  <div className="c-steps__circle" />
                </div>
              </li>
              <li className="o-list-bare__item c-steps__item">
                <div className="c-steps__step c-steps__step">
                <div className="c-steps__text">{lang === 'eng' ? 'Vehicles' : 'Vehículos'}</div>
                  <div className="c-steps__circle" />
                </div>
              </li>
              <li className="o-list-bare__item c-steps__item">
                <div className="c-steps__step">
                  <div className="c-steps__text">{lang === 'eng' ? 'Documents' : 'Documentos' }</div>
                  <div className="c-steps__circle" />
                </div>
              </li>
              <li className="o-list-bare__item c-steps__item">
                <div className="c-steps__step">
                <div className="c-steps__text">{lang === 'eng' ? 'Finish' : 'Finalizar' }</div>                  <div className="c-steps__circle" />
                </div>
              </li>
            </ul>
          </div>
          <div className="c-content">
            <div className="c-adding">
              <h2 className="c-adding__title">{lang === 'eng' ? 'Adding New Drivers' : 'Agrega conductores'}</h2>
              <div className="c-adding__text">
                <p>
                {lang === 'eng' ?  'You can add up to 45 drivers.' : 'Puede agregar hasta 45 conductores. '}
             
                </p>
                <p style={{ color: '#242424' }}>{lang === 'eng' ? 'Click here to add Drivers.' : 'Haz clic aquí para agregar conductores:'} </p>
              </div>
              <div className="c-adding__control">
                <button className="c-button c-button--blue" type="button" onClick={nextStep} >
                  <span className="o-icon">
                    <svg aria-hidden="true" focusable="false" role="img">
                      <use href="images/icons/icons.svg#icon-plus" />
                    </svg>
                  </span>
                 {lang === 'eng' ? ' Add Driver' : 'Agregar conductor'}
                </button>
              </div>
              <div className="c-adding__image">
                <img
                  src="images/components/ima-add.svg"
                  aria-hidden="true"
                  width={240}
                  height={167}
                />
              </div>
            </div>
            <div className="c-quote__controls">
              <button
                className="c-quote__control c-quote__control--previous c-button c-button--linear-indingo"
                type="button"
                onClick={backStep}
              >

                {lang === 'eng' ? 'Previous' : 'Atrás'}
              </button>
              
              <button
                className="c-quote__control c-quote__control--submit c-button c-button--disabled"
                type="button"
                onClick={nextStepby2}
                disabled
              >
                {lang === 'eng' ? 'Continue' : 'Continuar'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
  <footer className="c-site-footer">
    <div className="o-wrapper">
      <div className="c-site-footer__legal">
        <p className="c-site-footer__legal_text">
          © 2023 Bluefire Insurance Services Inc.
          <br />
          {lang === 'eng' ? <>List Of Entity/License Numbers Per State Located On  <br/></> : <>Listado de entidades/números de licencia por estado <br /> localizada en nuestra página de</>}  
  <a href="https://www.bluefireinsurance.com/affiliate-disclosure/" target="_blank" rel="noopener noreferrer">
    {lang === 'eng'? "Affiliate Disclosure Page." : " Aviso de Nuestras Filiales"} 
  </a>

        </p>
          <ul className="o-list-bare c-site-footer__legal_links">
  <li className="o-list-bare__item c-site-footer__legal-link">
    <a href="https://www.bluefireinsurance.com/privacy-policy/" target="_blank" rel="noopener noreferrer">
      { lang=== 'eng' ? ` Privacy Policy` : `Políticas de privacidad`}
    </a>
  </li>
  {window.innerWidth <= 768 && lang !== 'eng' ? (
    <>
      <li className="o-list-bare__item c-site-footer__legal-link">
        <a href="https://www.bluefireinsurance.com/california-consumer-privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ whiteSpace: 'normal' }}>
          {lang === 'eng' ? "California Consumer Privacy Policy" : "Política de Privacidad del"}
        </a>
      </li>
      <li className="o-list-bare__item c-site-footer__legal-link spanish-consumer-link">
        <a href="https://www.bluefireinsurance.com/california-consumer-privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ whiteSpace: 'normal' }}>
          {lang === 'eng' ? "" : "Consumidor de California"}
        </a>
      </li>
    </>
  ) : (
    <li className="o-list-bare__item c-site-footer__legal-link ">
      <a href="https://www.bluefireinsurance.com/california-consumer-privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ whiteSpace: 'normal' }}>
        {lang === 'eng' ? "California Consumer Privacy Policy" : "Política de Privacidad del Consumidor de California"}
      </a>
    </li>
  )}
  <li className="o-list-bare__item c-site-footer__legal-link">
    <a href="https://www.bluefireinsurance.com/terms-of-use/" target="_blank" rel="noopener noreferrer">
      {lang === 'eng' ? " Terms of Use" : "Condiciones de uso"}
    </a>
  </li>
</ul>
      </div>
    </div>
  </footer>
</>

    
   );
}
export default BfFormstep21;